"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated use 2 separate date pickers or number inputs instead
 * Created by Mariam.Melkonyan on 8/31/2016.
 */
var core_1 = require("@angular/core");
/**
 * @deprecated use Material Dialog instead.
 * This component provides the functionality of popup window. All the components that should be opened in popup windows,
 * should extend this component and use its functionality.
 */
require("./sis-popup-window.component.css");
var PopupWindow = /** @class */ (function () {
    function PopupWindow(elementRef) {
        /**
         * Determines event emitter that raises events before closing the popup window.
         * @type {EventEmitter<any>}
         */
        this.onClose = new core_1.EventEmitter();
        /**
         * Determines if the window should be modal
         * @type {boolean}
         * @default
         * @protected
         */
        this._isModal = true;
        /**
         * Determines if the user can drag the window
         * @type {boolean}
         * @default
         * @protected
         */
        this._isDraggable = true;
        /**
         * Determines if the use can resize the window
         * @type {boolean}
         * @default
         * @protected
         */
        this._isResizeable = true;
        /**
         * Determines the width of the window
         * @type {any}
         * @default
         * @private
         */
        this._width = 1000;
        this.initialized = false;
        /**
         * Determines the height of the window
         * @type {any}
         * @default
         * @private
         */
        this._height = 1000;
        /**
         * Determines the title of the window
         * @type {string}
         * @private
         */
        this._title = "";
        this._elementRef = elementRef;
    }
    Object.defineProperty(PopupWindow.prototype, "width", {
        get: function () {
            return this._width;
        },
        set: function (width) {
            this._width = width;
            if (this._popupWindow) {
                this._popupWindow.width(this._width);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PopupWindow.prototype, "height", {
        get: function () {
            return this._height;
        },
        set: function (height) {
            this._height = height;
            if (this._popupWindow) {
                this._popupWindow.height(this._height);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PopupWindow.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (title) {
            this._title = title;
            if (this._popupWindow) {
                this._popupWindow.title(this._title);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The popup window is created after the view is initialized.
     */
    PopupWindow.prototype.ngAfterViewInit = function () {
        if (!this.initialized) {
            this._createPopupWindow();
            this.initialized = true;
        }
    };
    /**
     * Destroys popup window component.
     */
    PopupWindow.prototype.ngOnDestroy = function () {
        this._popupWindow.destroy();
    };
    /**
     * Created the Kendo UI window according to the given parameters (width, height, title, etc.)
     * All the parameters can be overwritten by the components which derive from this component
     * to use popup window functionality
     * @protected
     */
    PopupWindow.prototype._createPopupWindow = function () {
        var t = this;
        $(this._elementRef.nativeElement).kendoWindow({
            modal: t.isModal(),
            animation: false,
            draggable: t.isDraggable(),
            resizable: t.isResizeable(),
            title: t.title,
            width: t.width,
            height: t.height,
            close: function (e) {
                t.onClose.emit(e);
            }
        });
        $(this._elementRef.nativeElement).data("kendoWindow").wrapper.attr("id", this.id + "-popup-container");
        this._popupWindow = $(this._elementRef.nativeElement).data("kendoWindow").center();
    };
    /**
     * Opens the popup window.
     */
    PopupWindow.prototype.open = function () {
        this._popupWindow.center().open();
    };
    /**
     * Closes the popup window.
     */
    PopupWindow.prototype.close = function () {
        this._popupWindow.close();
    };
    PopupWindow.prototype.isModal = function () {
        return this._isModal;
    };
    PopupWindow.prototype.isDraggable = function () {
        return this._isDraggable;
    };
    PopupWindow.prototype.isResizeable = function () {
        return this._isResizeable;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PopupWindow.prototype, "id", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], PopupWindow.prototype, "onClose", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], PopupWindow.prototype, "width", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], PopupWindow.prototype, "height", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], PopupWindow.prototype, "title", null);
    PopupWindow = __decorate([
        core_1.Component({
            
            selector: "sis-popup-window",
            template: require('./sis-popup-window.component.html'),
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], PopupWindow);
    return PopupWindow;
}());
exports.PopupWindow = PopupWindow;
//# sourceMappingURL=sis-popup-window.component.js.map